/**
 * Canonical Gemini Model Definitions
 * Jediné centrální místo v kódu pro všechny modely Gemini v celé aplikaci
 * (Layout Orchestrator, Room Architect Chatbot, Intelligent Zoning).
 *
 * Povoleno pouze 3 specifické modely:
 * 1. gemini-4-argon       (Gemini 4 Argon - Nejvýkonnější reasoning)
 * 2. gemini-3.8-flash     (Gemini 3.8 Flash - Doporučeno)
 * 3. gemini-3.5-flash-lite (Gemini 3.5 Flash Lite)
 */

export interface GeminiModelInfo {
  id: string;
  name: string;
  description: string;
  isDefault?: boolean;
}

export const AVAILABLE_GEMINI_MODELS: readonly GeminiModelInfo[] = [
  {
    id: 'gemini-4-argon',
    name: 'Gemini 4 Argon (Nejvýkonnější)',
    description: 'Vlajkový model pro komplexní architektonické uvažování a vícekriteriální prostorové plánování',
    isDefault: false
  },
  {
    id: 'gemini-3.8-flash',
    name: 'Gemini 3.8 Flash (Doporučeno)',
    description: 'Hlavní doporučený model s vysokou inteligencí, rychlostí a přesnou prostorovou logikou',
    isDefault: true
  },
  {
    id: 'gemini-3.5-flash-lite',
    name: 'Gemini 3.5 Flash Lite',
    description: 'Lehký a rychlý model pro okamžité generování a nízkou latenci',
    isDefault: false
  }
] as const;

export const DEFAULT_GEMINI_MODEL = 'gemini-3.8-flash';

/**
 * Helper to validate or fallback to the default Gemini model ID.
 */
export function resolveGeminiModel(modelId?: string): string {
  if (!modelId) return DEFAULT_GEMINI_MODEL;
  const found = AVAILABLE_GEMINI_MODELS.find(m => m.id === modelId);
  return found ? found.id : DEFAULT_GEMINI_MODEL;
}
